import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {CreateAccountPersonRequest, PaymentGroupModel, PaymentMethod, PropertyPaymentMethodHinge, RIQPaymentRequest} from '../models/PaymentModels';
import {ChannelEvent, ChannelService} from './channel.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {GroupModel} from '../decision-grid/Models/group-model';
import { AuthService } from './auth.service';
import { ScreeningDraft } from '../models/screeningDraft';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {
  constructor(private http: HttpClient, private channels: ChannelService, private modalService: NgbModal, private toast: ToastrService, private auth : AuthService) {
    // any time a payment method is added and THIS user is notified, refetch pmt methods
    this.channels.sub('PaymentMethodAdded').subscribe((ev: ChannelEvent) => {
      this.LoadUserPaymentMethods();
    });

    // TODO: we need similar handling for deletes, once implemented
    this.channels.sub('DeactivatePaymentMethod').subscribe((ev: ChannelEvent) => {
      this.LoadUserPaymentMethods();
    });

  }
  public processing : boolean = false;
  public $lastAddedPaymentGroup = new Subject<PaymentGroupModel>();
  public $displayPaymentModal = new BehaviorSubject<boolean>(false);

  _paymentMethods: PaymentMethod[] = [];
  public get paymentMethods(): PaymentMethod[] {
    if(this.auth.UserInRole('Admin')) {
      return this._paymentMethods.filter(r => {
        return r.isActive;
      });
    } else {
      return this._paymentMethods.filter(r => {return r.isActive && r.riqUserId === this.auth.loggedInUser.id });
    }
  }


  //#region Hooks for processing

  //#endregion

  public LoadUserPaymentMethods(locId : number = undefined, clientId : number = undefined, selectedMethodId : number = undefined) : void {
    this.processing = true;
    this._paymentMethods = [];
    console.info(`Loading payment methods with params : location : ${locId}, client : ${clientId} selected method Id : ${selectedMethodId}`);
    this.FetchPaymentMethods(locId, clientId).subscribe((res : PaymentMethod[]) => {
      if(!res) this._paymentMethods = [];
      else this._paymentMethods = res;
      this.processing = false;
      if(selectedMethodId){
        var instance = this._paymentMethods.find(pmt => {return pmt.id == selectedMethodId;});
        if(instance) instance.selected = true;
      }
    },
    err =>
    {
      this.toast.error('There was an error loading your payment methods. please contact support for help.','Error Loading Payment Methods');
      this.processing = false;
    });

  }


  SavePayer(model: CreateAccountPersonRequest) {
    return this.http.post(environment.baseURl + '/api/payment/aptexx/setup', model);
  }

  FetchPaymentMethods(locId: number = 0, clientId: number = 0) {
    if(locId > 0) return this.http.get<PaymentMethod[]>(environment.baseURl + `/api/payment/methods/list/property/${locId}`);
    else if(clientId > 0) return this.http.get<PaymentMethod[]>(environment.baseURl + `/api/payment/methods/list/client/${clientId}`);
  }

  // this will pull based on the user Id, don't need to specify a user id
  FetchPaymentProviderAccount() {
    return this.http.get<CreateAccountPersonRequest>(environment.baseURl + '/api/payment/methods/user');
  }

  EditPaymentMethod(pmt: PaymentMethod) {
    return this.http.post(environment.baseURl + '/api/payment/update', pmt);
  }

  AssignPaymentMethod(hinge: PropertyPaymentMethodHinge) {
    return this.http.post(environment.baseURl + '/api/payment/associate', hinge);
  }

  DeletePaymentMethod(method: PaymentMethod): void {
    this.http.post(environment.baseURl + '/api/payment/deactivate', method).subscribe(r => {
        this.modalService.dismissAll();
        this.toast.success('Payment method removed!', '');
        this.LoadUserPaymentMethods();
      },
      err => this.toast.error('There was an error deleting your payment method!', '', {disableTimeOut: true, closeButton: true}));
  }

  public loadPaymentGroups(clientId: number): Observable<PaymentGroupModel[]> {
    // TODO this needs to change for groups endpoint for payments
    return this.http.get<PaymentGroupModel[]>(`${environment.baseURl}/api/payment/groups/fetch/${clientId}`);
  }

  public savePaymentGroup(group: GroupModel): Observable<PaymentGroupModel> {
    return this.http.post<PaymentGroupModel>(environment.baseURl + '/api/payment/group', group);
  }

  sendPayment(pmt : RIQPaymentRequest): Observable<any> {
    this.processing = true;
    return this.http.post(environment.baseURl + '/api/payment/makepayment', pmt);
  }

  FetchGuestPaymentURLForDraft(draft: ScreeningDraft){
    return this.http.post<any>(environment.baseURl + '/api/payment/guestpayment', draft);
  }

}
